import { render, staticRenderFns } from "./TeamsEmptyState.vue?vue&type=template&id=3c2e299b"
import script from "./TeamsEmptyState.vue?vue&type=script&lang=js"
export * from "./TeamsEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports